import React, { useCallback, useMemo } from 'react';
import { useIntl, history } from 'umi';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import SvgIcon from '@home/components/SvgIcon';
import componentMap from '@/pages/dashboard/_config/compConfig';
import { goStatsDetailAction } from '@op/pages/stats/Detail';
import './index.scss';
import { JumpType, navigate } from '@home/utils/utils';
interface IMetricCardTitleProps {
  filter: any;
  isOpinionsUrl?: boolean; // 是否舆情跳转
  className?: string;
  gameInfo?: any;
  id?: string;
  index: number;
  refArray?: any[];
  scrollStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  titleEn: string;
  titleCn: string;
  jumpUrl?: string;
  gameCode?: string;
  children?: React.ReactNode;
  rightSlot?: {
    name: string;
    props?: any;
  };
  data?:any;
  // 是否隐藏右侧插槽
  hideRightSlot?: boolean;
  // 编辑后更新模块
  refresh?: ()=>void;
}

export default function CommonTitle(props: IMetricCardTitleProps) {
  const { titleEn, titleCn, jumpUrl = '', id = '', gameCode, children, rightSlot, className = '', style,
    refArray, index, scrollStyle, isOpinionsUrl, hideRightSlot, gameInfo, ...restProps } = props;
  const { locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  
  // 左侧插槽
  const renderrightSlot = useCallback(() => {
    if (!rightSlot || hideRightSlot) return null;
    const { name, ...resetProp } = rightSlot || {};
    const RightSlotCom = componentMap?.[name];
    return RightSlotCom ? <RightSlotCom
      {...(restProps || {})}
      {...(resetProp || {})}
      gameInfo={gameInfo}
    /> : null;
  }, [rightSlot, restProps]);

  const filterParams = useMemo(() => {
    if (!props?.filter) return {};
    return {
      date_type: props?.filter?.date_type || '',
      start_time: props?.filter?.start_time || '',
      end_time: props?.filter?.end_time || '',
    };
  }, [props?.filter]);

  const clickJump = (url: string) => {
    if (!url) return;
    const splitString = url?.includes('?') ? '&' : '?';
    const opinionsUrl = `${url}${splitString}gameid=${gameInfo?.edition_unified_id }`;
    navigate(isOpinionsUrl ? opinionsUrl : url, { jumpType: JumpType.Window, windowParams: filterParams });

    // 下钻逻辑
    // if (isOpinionsUrl) {
    //   const splitString = url?.includes('?') ? '&' : '?';
    //   return goStatsDetailAction({
    //     path: `${url}${splitString}gameid=${gameInfo?.edition_unified_id }`,
    //     params: {
    //       ...props?.filter,
    //     },
    //     history,
    //   });
    // }
    // history?.push(url);
  };

  return (
    <div id={id} data-scroll-index={index} ref={refArray?.[index]} style={scrollStyle}>
      <div
        className={`dbh-common-title ${className}`}
        style={style}
      >
        <div className={`${jumpUrl ? 'dbh-common-title-hover' : ''}`} onClick={() => jumpUrl && clickJump(jumpUrl)}>
          <span className="dbh-common-title-text">{getLanguage(isEN, titleEn, titleCn)}</span>
          {jumpUrl && <SvgIcon type="studio-arrow" className="dbh-common-title-icon" />}
        </div>

        {
          rightSlot && <div>
            {renderrightSlot()}
          </div>
        }
      </div>
      {React.Children.map(children, (child: any) => React.cloneElement(
        child,
        {
          ...restProps,
          refArray,
          gameInfo,
          state: {}
        }
      ))}
    </div>
  );
};